var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "push-template1"
  }, [_c('div', {
    staticClass: "img-content",
    style: {
      height: _vm.conHeight
    },
    on: {
      "click": function ($event) {
        return _vm.goThird('title');
      }
    }
  }, [_c('img', {
    staticClass: "img-item",
    attrs: {
      "src": _vm.cover.src,
      "onerror": `javascript:this.src='${_vm.defaultImg}';`
    }
  })]), _c('div', {
    staticClass: "content",
    style: _vm.contentBgColor,
    on: {
      "click": function ($event) {
        return _vm.goThird('title');
      }
    }
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.push_title))]), _vm.push_third_text ? _c('div', {
    staticClass: "content-more"
  }, [_c('div', {
    staticClass: "content-more-title",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goThird('btn');
      }
    }
  }, [_vm._v(_vm._s(_vm.push_third_text))])]) : _vm._e()]), _vm.push_content ? _c('contentText', {
    staticClass: "content-style",
    attrs: {
      "text": _vm.push_content,
      "is-click-show": false
    },
    on: {
      "content-open": _vm.goThird
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };